import React from 'react';
import { Database, Server, Clock, Zap } from 'lucide-react';

const SystemMetrics = ({ metrics }) => {
  if (!metrics) {
    return null;
  }

  const metricCards = [
    {
      label: 'API Response Time',
      value: `${metrics.avgResponseTime || 0}ms`,
      description: 'Average (last hour)',
      icon: Zap,
      color: 'blue'
    },
    {
      label: 'Database Queries',
      value: metrics.dbQueryCount || 0,
      description: 'Last hour',
      icon: Database,
      color: 'green'
    },
    {
      label: 'Active Connections',
      value: metrics.activeConnections || 0,
      description: 'Current',
      icon: Server,
      color: 'purple'
    },
    {
      label: 'Requests/min',
      value: metrics.requestsPerMinute || 0,
      description: 'Average',
      icon: Clock,
      color: 'orange'
    }
  ];

  const colorClasses = {
    blue: 'bg-blue-100 text-blue-600',
    green: 'bg-green-100 text-green-600',
    purple: 'bg-purple-100 text-purple-600',
    orange: 'bg-orange-100 text-orange-600'
  };

  return (
    <div className="bg-white shadow rounded-lg">
      <div className="px-6 py-5 border-b border-gray-200">
        <h3 className="text-lg font-medium text-gray-900">Performance Metrics</h3>
      </div>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 p-6">
        {metricCards.map((metric) => {
          const Icon = metric.icon;
          return (
            <div key={metric.label} className="flex items-start">
              <div className={`rounded-lg p-3 ${colorClasses[metric.color]}`}>
                <Icon className="w-6 h-6" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-500">
                  {metric.label}
                </p>
                <p className="text-2xl font-semibold text-gray-900">
                  {metric.value}
                </p>
                <p className="text-xs text-gray-500 mt-1">
                  {metric.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SystemMetrics;
